<template>
  <v-list>
    <draggable
      v-bind="dragOptions"
      tag="div"
      class="widget-item-container mb-2"
      :list="list"
      :value="value"
      @input="inputEmit"
      @change="changeEmit"
      @start="startEmit"
      @end="endEmit"
      swapThreshold="1"
    >
      <transition-group type="transition" :name="!drag ? 'flip-list-move' : null">
        <v-list-item v-for="(opt, key) in realValue" :key="key" class="pl-0">
          <v-list-item-avatar class="cursor-grab px-0 mx-0">
            <v-icon class="justify-start">mdi-drag</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <b class="text-overline">Text:</b>
              <v-chip small color="purple lighten-5">{{opt.text}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>
              <b class="text-overline">Value:</b>
              <v-chip small color="purple lighten-5">{{opt.value}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <div>
              <v-btn small icon color="purple lighten-2" @click="$emit('getInputOption', opt.code)">
                <v-icon size="18">mdi-pen</v-icon>
              </v-btn>
              <v-btn
                small
                icon
                color="purple lighten-2"
                @click="$emit('deleteInputOption', opt.code)"
              >
                <v-icon size="18">mdi-delete-outline</v-icon>
              </v-btn>
            </div>
          </v-list-item-action>
        </v-list-item>
      </transition-group>
    </draggable>
  </v-list>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "InputOptionsList",
  components: {
    draggable
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    }
  },
  data: () => ({
    drag: false,
  }),
  methods: {
    changeEmit(value) {
      this.$emit("change", value);
    },
    inputEmit(value) {
      this.$emit("input", value);
    },
    startEmit(){
      this.drag = true;
    },
    endEmit(){
      this.drag = false;
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "widget",
        disabled: false,
        ghostClass: "ghost",
        put: () => true,
        pull: false
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    }
  }
};
</script>

<style>
.cursor-grab {
  cursor: grab;
}

.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>